import { LocationZerezes } from './LocationZerezes';
import { User } from './User';
import { UserProfileConfig } from './UserProfileConfig';
import { UserRestriction } from './UserRestriction';

export class Session {
  token?: string;
  user?: User;
  locations?: LocationZerezes[];
  date?: Date;
  sessionExpiresAtUtcDate?: Date|null;
  sessionExpiresAtAmericaSaoPauloDate?: Date|null;
  userProfileConfig?: UserProfileConfig|null;
  restrictions?: UserRestriction[];
}